import { AddressModel } from "@skylab-shared/dataModel";

type Result = {
	parsed?: Parsed | null
	address: string
};

type Parsed = {
	zipCode: string,
	city: string
}

export class EPurchaseSellerAddressParser {
	public static parse(source: AddressModel): Result {
		try {
			if (!source) return {
				parsed: null,
				address: ''
			};

			const line2Data = this.parseLine2(source.line2);
			if (line2Data) {
				return {
					address: source.line1,
					parsed: line2Data
				}
			}

			const line1Data = this.parseLine1(source.line1);
			if (line1Data) {
				return {
					address:[ line1Data.address, source.line2].filter(Boolean).join(', '),
					parsed: line1Data.parsed
				}
			}

			return this.getDefaultValue(source);
		} catch (err) {
			return this.getDefaultValue(source);
		}
	}

	private static getDefaultValue(source: AddressModel): Result {
		return {
			parsed: null,
			address: [source.line1, source.line2].filter(Boolean).join(', ')
		};
	}

	private static parseLine2(line2: string | null | undefined): Parsed | null{
		if (!line2) return null;

		const match = line2.trim().match(
			/^(?<code>\d{2}-\d{3})\s+(?<rest>.+)$|^(?<rest2>.+)\s+(?<code2>\d{2}-\d{3})$/
		);

		if (match) {
			const zipCode = (match.groups?.["code"] || match.groups?.["code2"])?.trim();
			const city = (match.groups?.["rest"] || match.groups?.["rest2"])?.trim();

			return { city: city!, zipCode: zipCode! }
		}

		return null;
	}

	private static parseLine1(line1: string | null | undefined): Result | null {
		if (!line1) return null;

		const match = line1.trim().match(
			 /^(?<street1>.*?)\s*,?\s*(?<zipcode1>\d{2}-\d{3})\s+(?<city1>[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż\s-]+)$|^(?<zipcode2>\d{2}-\d{3})\s+(?<city2>[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż\s-]+)\s*,\s*(?<street2>.+)$/
		);

		if (match) {
			const address = (match.groups?.["street1"] || match.groups?.["street2"])?.trim();
			const zipCode = (match.groups?.["zipcode1"] || match.groups?.["zipcode2"])?.trim();
			const city = (match.groups?.["city1"] || match.groups?.["city2"])?.trim();

			return {
				parsed: { city: city!, zipCode: zipCode! },
				address: address!
			 }
		}

		return null;
	}
}